import React, { PureComponent } from 'react';
import { Button, PopOver, Portal } from '@tencent/spaui';
import './guide-manager.scoped.scss';

class GuideManager extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      index: 0,
      displayGuideList: [],
      positionTop: null,
      positionLeft: null,
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const { flag, guidList = [] } = this.props;
    const displayGuideList = guidList
      .map((item) => {
        const el = document.querySelector(`#${item.key}[data-mark='guide']`);
        return {
          ...item,
          el,
        };
      })
      .filter((item) => item.el);

    setTimeout(() => {
      const hasGuide = localStorage.getItem(flag);
      if (displayGuideList.length && !hasGuide) {
        const position = this.calculatePosition(0, displayGuideList);
        this.setState({ show: true, displayGuideList, ...position });
      }
    });
  }

  handlePre = () => {
    const { index } = this.state;
    if (index > 0) {
      this.setState({ index: index - 1 });
    }
  };

  handleNext = () => {
    const { displayGuideList, index } = this.state;
    if (index < displayGuideList.length - 1) {
      this.setState({ index: index + 1 });
    } else {
      this.handleClose();
    }
  };

  handleClose = () => {
    // eslint-disable-next-line react/prop-types
    const { flag } = this.props;
    localStorage.setItem(flag, 1);
    this.setState({ show: false });
  };

  render() {
    const { show, displayGuideList, index, positionTop, positionLeft } = this.state;
    const currentItem = displayGuideList[index] || {};
    if (!show) {
      return null;
    }
    if (!positionLeft) {
      return null;
    }

    return (
      <Portal>
        <PopOver
          // positionTarget={el}
          show={show}
          positionTop={positionTop}
          positionLeft={100}
          style={{
            color: 'white',
            maxWidth: '260px',
            border: 'none',
            background: '#296bef',
            transform: `translateX(${positionLeft - 235}px)`,
          }}
          className="single-guide-popover"
        >
          <h4 className="spaui-popover-title" style={{ color: 'white', paddingLeft: '0' }}>
            {currentItem.label}({index + 1}/{displayGuideList.length})
          </h4>
          <div
            style={{
              position: 'absolute',
              opacity: '0.8',
              color: 'white',
              right: '22px',
              top: '25px',
              cursor: 'pointer',
            }}
            onClick={this.handleClose}
          >
            跳过
          </div>
          <div className="spaui-popover-body" style={{ color: 'white', lineHeight: '22px', padding: '10px 0 20px' }}>
            {currentItem.desc}
          </div>

          <div className="spaui-popover-footer">
            {index > 0 ? (
              <Button bsStyle="primary" onClick={this.handlePre}>
                上一步
              </Button>
            ) : null}
            <Button displayType="default" style={{ color: '#296bef' }} onClick={this.handleNext}>
              {index === displayGuideList.length - 1 ? '完成' : '下一步'}
            </Button>
          </div>

          <a className="spaui-popover-close" href="#" onClick={this.handleClose}>
            <i className="spaui-icon icon-plus icon-close" />
          </a>
        </PopOver>
      </Portal>
    );
  }

  calculatePosition(index, displayGuideList) {
    const currentItem = displayGuideList[index] || {};
    const el = document.querySelector(`#${currentItem.key}[data-mark='guide']`);
    if (el) {
      const { left, right, bottom } = el.getBoundingClientRect();
      return {
        positionTop: bottom,
        positionLeft: (left + right) / 2 + document.documentElement.scrollLeft,
      };
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevState.index !== this.state.index) {
      return this.calculatePosition(this.state.index, this.state.displayGuideList);
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.setState(snapshot);
    }
  }
}

export default GuideManager;
